import React from 'react';
import PropTypes from 'prop-types';
import Button from '../CommonComponents/Button';
import { sortOption } from './LeadsConsts';
import { defaultSortBy, defaultOrderBy } from './LeadsReducer';

class View extends React.Component {
  componentDidMount() {
    const { fetchLeads, sortBy, orderBy, portalName } = this.props;

    document.title = `Leads | ${portalName}`;

    fetchLeads(sortBy, orderBy);
  }

  render() {
    const {
      fetchLeads,
      fetchNextPageLeads,
      leadsList,
      nextPage,
      orderBy,
      resetOrder,
      resetSort,
      setClient,
      setSortBy,
      showPagination,
      sortBy,
      totalAssets,
      totalLeads,
      nextOrderBy,
      setOrderBy,
    } = this.props;

    return (
      <div className="leads">
        <h1 className="leads__title">Leads</h1>
        <Button
          prependIcon="fa fa-sync-alt"
          className="leads__refresh-button"
          onClick={() => {
            resetOrder();
            resetSort();
            fetchLeads(defaultSortBy, defaultOrderBy);
          }}
        >
          refresh
        </Button>

        <ul className="leads__details__list">
          <li className="leads__details__item">
            <div>
              <h3 className="leads__details__title">Total Investments Assets</h3>
              <p className="leads__details__value">
                $ {ADV.util.formatValue(totalAssets, 'money')}
              </p>
            </div>
          </li>
          <li className="leads__details__item">
            <div>
              <h3 className="leads__details__title">Total Leads</h3>
              <p className="leads__details__value">{totalLeads}</p>
            </div>
          </li>
        </ul>

        <div className="leads__table-container">
          <div className="leads__table-title">All Leads</div>
          <div
            className={`
              leads__table
              ${showPagination ? 'has-pagination-footer' : ''}
            `}
          >
            <ul className="leads__table-header--list">
              <li className="leads__table-header--list-item">Advisor</li>
              <li className="leads__table-header--list-item">Name</li>
              <li className="leads__table-header--list-item">Email Address</li>
              <li
                className="
                leads__table-header--list-item
                leads__table-header--list-item__phone-number"
              >
                Phone Number
              </li>
              <li className="leads__table-header--list-item">
                <Button
                  appendIcon="fa fa-caret-down"
                  className="leads__table-header--list-item--button"
                  onClick={() => {
                    setOrderBy(nextOrderBy);
                    setSortBy(sortOption.salary);
                    fetchLeads(sortOption.salary, nextOrderBy);
                  }}
                >
                  Income
                </Button>
              </li>
              <li className="leads__table-header--list-item">
                <Button
                  appendIcon="fa fa-caret-down"
                  className="leads__table-header--list-item--button"
                  onClick={() => {
                    setOrderBy(nextOrderBy);
                    setSortBy(sortOption.assets);
                    fetchLeads(sortOption.assets, nextOrderBy);
                  }}
                >
                  Total Assets
                </Button>
              </li>
              <li className="leads__table-header--list-item">
                <Button
                  appendIcon="fa fa-caret-down"
                  className="leads__table-header--list-item--button"
                  onClick={() => {
                    setOrderBy(nextOrderBy);
                    setSortBy(sortOption.date);
                    fetchLeads(sortOption.date, nextOrderBy);
                  }}
                >
                  Date Created
                </Button>
              </li>
            </ul>
            {leadsList.map((lead, index) => (
              <div
                className={`
                  leads__table-values--list
                  ${lead.HasAccessToConsumer ? 'has-cursor-pointer' : ''}
                `}
                key={`${lead.ConsumerId}-${index}`}
                onClick={() => {
                  if (lead.HasAccessToConsumer) {
                    setClient(lead.ConsumerId);
                  }
                }}
                role="button"
                tabIndex="0"
                onKeyPress={() => {}}
              >
                <span className="leads__table-values--list-item adviser-name-row">
                  {lead.DesignatedAdviserName}
                </span>
                <span className="leads__table-values--list-item name-row">{lead.Name}</span>
                <span className="leads__table-values--list-item">{lead.Email}</span>
                <span
                  className="
                  leads__table-values--list-item
                  leads__table-values--list-item__phone-number"
                >
                  {lead.PhoneNumber}
                </span>
                <span className="leads__table-values--list-item">
                  $ {ADV.util.formatValue(lead.Salary, 'money')}
                </span>
                <span className="leads__table-values--list-item">
                  $ {ADV.util.formatValue(lead.TotalAssets, 'money')}
                </span>
                <span className="leads__table-values--list-item">
                  {moment(new Date(lead.DateCreated)).format('MM/DD/YYYY')}
                </span>
              </div>
            ))}
          </div>
          {showPagination && leadsList.length > 0 && (
            <div className="leads__table-values--show-more--container">
              <Button
                className="leads__table-values--show-more--button"
                onClick={() => {
                  fetchNextPageLeads(nextPage, sortBy, orderBy);
                }}
              >
                Show more
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

View.defaultProps = {
  nextPage: null,
};

View.propTypes = {
  fetchLeads: PropTypes.func.isRequired,
  sortBy: PropTypes.oneOf(['salary', 'assets', 'date']).isRequired,
  orderBy: PropTypes.oneOf(['asc', 'desc']).isRequired,
  leadsList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  totalAssets: PropTypes.number.isRequired,
  totalLeads: PropTypes.number.isRequired,
  setSortBy: PropTypes.func.isRequired,
  resetOrder: PropTypes.func.isRequired,
  resetSort: PropTypes.func.isRequired,
  showPagination: PropTypes.bool.isRequired,
  fetchNextPageLeads: PropTypes.func.isRequired,
  nextPage: PropTypes.func,
  setClient: PropTypes.func.isRequired,
  nextOrderBy: PropTypes.string.isRequired,
  setOrderBy: PropTypes.func.isRequired,
  portalName: PropTypes.string.isRequired,
};

export default View;
